import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL as string;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "enfleet_token";

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function errorMessage(e: unknown): string {
  const err = e as { response?: { data?: { detail?: unknown } }; message?: string };
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail === "object" && typeof (detail as { msg?: string }).msg === "string") return (detail as { msg: string }).msg;
  return String(detail);
}

export function jobSheetUrl(woId: string): string {
  return `${API}/workorders/${woId}/pdf?auth=${encodeURIComponent(getToken() || "")}`;
}

export function fileUrl(fileId: string): string {
  return `${API}/files/${fileId}/download?auth=${encodeURIComponent(getToken() || "")}`;
}

export function invoicePdfUrl(invoiceId: string): string {
  return `${API}/invoices/${invoiceId}/pdf?auth=${encodeURIComponent(getToken() || "")}`;
}

export function receiptPdfUrl(invoiceId: string): string {
  return `${API}/invoices/${invoiceId}/receipt-pdf?auth=${encodeURIComponent(getToken() || "")}`;
}

export function statementPdfUrl(year: number, tenantId?: string): string {
  return `${API}/invoices/statement/${year}/pdf?auth=${encodeURIComponent(getToken() || "")}${tenantId ? `&tenant_id=${tenantId}` : ""}`;
}

export function avatarUrl(userId: string, cacheKey?: string | null): string {
  return `${API}/auth/avatar/${userId}${cacheKey ? `?v=${cacheKey}` : ""}`;
}

export function vehiclePhotoUrl(vehicleId: string, cacheKey?: string | null): string {
  return `${API}/public/vehicles/${vehicleId}/photo${cacheKey ? `?v=${cacheKey}` : ""}`;
}

export function logoUrl(tenantId: string, cacheKey?: string | null): string {
  return `${API}/tenants/${tenantId}/logo${cacheKey ? `?v=${cacheKey}` : ""}`;
}
